import React from 'react'
import './about.css'
import Card from './work_experience/card'
import Card1 from './position_of_responsibility/card'
import LottieAnimation from '../../Lottie';
import home from '../../Animations/dev.json';
import HiImg from '../../Animations/Hi-Img.json'

function about() {
    return (
        <div>
            {/* About me section */}
            <header className='text-2xl font-bold pt-10 pb-5 items-start px-5'>
                <h2 className="heading text-yellow-600">About Me</h2>
            </header>


            {/* <section class="text-gray-400 bg-gray-900 body-font">
                <div class="container mx-auto flex px-5 py-1 md:flex-row flex-col items-center">
                    <div class="lg:flex-grow md:w-1/2 lg:pr-20 md:pr-16 flex flex-col md:items-start md:text-left mb-5 md:mb-0 items-center text-center">
                        <h1 class="title-font sm:text-2xl text-xl mb-4 font-extralight text-white">
                            <p className="para-font text-gray-200">
                                Hi Everyone 🙋‍♂️,<br></br> I am <span class="gradient-text text-font">Siddharth Singh.</span> <br></br>I am a Fullstack Developer from Bhopal, India.
                            </p>
                            <p className="para-font text-gray-200">
                                I am currently pursuring my B.Tech in Computer Science Engineering from SRMIST Delhi-NCR Campus Ghaziabad.
                            </p>
                            <p className="para-font text-gray-200">
                                I love making smooth apps with React, and robust backends with NodeJS & MongoDB.
                            </p>
                        </h1>
                        <p class="mb-8 leading-relaxed">Copper mug try-hard pitchfork pour-over freegan heirloom neutra air plant cold-pressed tacos poke beard tote bag. Heirloom echo park mlkshk tote bag selvage hot chicken authentic tumeric truffaut hexagon try-hard chambray.</p>
                    </div>
                    <div class="lg:max-w-md lg:w-full md:w-1/2 w-5/6">
                        <LottieAnimation lotti={home} />
                    </div>
                </div>
            </section> */}


            <section class="py-10 bg-gray-800">
                <div class="container items-center max-w-6xl px-4 mx-auto sm:px-20 md:px-32 lg:px-5">
                    <div class="flex flex-wrap items-center -mx-3">
                        <div class="order-1 w-full px-3 lg:w-1/2 lg:order-0">
                            <div class="w-full lg:max-w-md">
                                <h2 class="text-gray-100 mb-4 text-3xl font-bold leading-tight tracking-tight sm:text-4xl font-heading">Hi Everyone 🙋‍♂️, I'm
                                    <br /><span class="gradient-text text-3xl sm:text-4xl font-heading text-font">Siddharth Singh.</span></h2>
                                <p class="mb-4 font-medium tracking-tight text-gray-300 xl:mb-6">An Aspiring Software Developer from Bhopal, India.</p>
                                <ul>
                                    <li class="flex items-center py-2 px-5 space-x-4 xl:py-3">
                                        <ul class="list-disc">
                                            <li class="font-medium text-gray-300">I'm a Computer Science Engineering alumni from SRMIST Delhi-NCR Campus.</li>
                                        </ul>
                                    </li>
                                    <li class="flex items-center py-2 px-5 space-x-4 xl:py-3">
                                        <ul class="list-disc">
                                            <li class="font-medium text-gray-300">Skilled in Data Structures and Algorithms, I also possess a keen interest in fullstack development.</li>
                                        </ul>
                                    </li>
                                    <li class="flex items-center py-2 px-5 space-x-4 xl:py-3">
                                        <ul class="list-disc">
                                            <li class="font-medium text-gray-300">I'm open to work preferably not limited to, as a Full Stack Developer and looking forward to work on some challenging work using cutting edge technologies.</li>
                                        </ul>
                                    </li>
                                    <li class="flex items-center py-2 px-5 space-x-4 xl:py-3">
                                        <ul class="list-disc">
                                            <li class="font-medium text-gray-300">So let's have a coffee and code?</li>
                                        </ul>
                                    </li>

                                    {/* <li class="flex items-center py-2 space-x-4 xl:py-3">
                                        <svg class="w-10 h-10 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"></path></svg>
                                        <span class="font-medium text-gray-300">I'm a 3rd year undergrad pursuing my B.Tech in Computer Science Engineering from SRM University.</span>
                                    </li>
                                    <li class="flex items-center py-2 space-x-4 xl:py-3">
                                        <svg class="w-10 h-10 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.356 3.356a1 1 0 0 0 1.414 0l1.586-1.586a1 1 0 0 0 0-1.414l-3.356-3.356a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814L1 0zm9.646 10.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708zM3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026L3 11z" /></svg>
                                        <span class="font-medium text-gray-300">Skilled in Data Structures and Algorithms, I also possess a keen interest in Web Development.
                                        </span>
                                    </li>
                                    <li class="flex items-center py-2 space-x-4 xl:py-3">
                                        <svg class="w-12 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path d="M.5 0a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0zM2 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z" /></svg>
                                        <span class="font-medium text-gray-300"> I`m looking forward to work on challenging projects that would enable me to learn new technologies while using my skills for the development of the organisation.
                                        </span>
                                    </li>
                                    <li class="flex items-center py-2 space-x-4 xl:py-3">
                                        <svg class="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.902.334a.5.5 0 0 1-.28.65l-2.254.902-.4 1.927c.376.095.715.215.972.367.228.135.56.396.56.82 0 .046-.004.09-.011.132l-.962 9.068a1.28 1.28 0 0 1-.524.93c-.488.34-1.494.87-3.01.87-1.516 0-2.522-.53-3.01-.87a1.28 1.28 0 0 1-.524-.93L3.51 5.132A.78.78 0 0 1 3.5 5c0-.424.332-.685.56-.82.262-.154.607-.276.99-.372C5.824 3.614 6.867 3.5 8 3.5c.712 0 1.389.045 1.985.127l.464-2.215a.5.5 0 0 1 .303-.356l2.5-1a.5.5 0 0 1 .65.278zM9.768 4.607A13.991 13.991 0 0 0 8 4.5c-1.076 0-2.033.11-2.707.278A3.284 3.284 0 0 0 4.645 5c.146.073.362.15.648.222C5.967 5.39 6.924 5.5 8 5.5c.571 0 1.109-.03 1.588-.085l.18-.808zm.292 1.756C9.445 6.45 8.742 6.5 8 6.5c-1.133 0-2.176-.114-2.95-.308a5.514 5.514 0 0 1-.435-.127l.838 8.03c.013.121.06.186.102.215.357.249 1.168.69 2.438.69 1.27 0 2.081-.441 2.438-.69.042-.029.09-.094.102-.215l.852-8.03a5.517 5.517 0 0 1-.435.127 8.88 8.88 0 0 1-.89.17zM4.467 4.884s.003.002.005.006l-.005-.006zm7.066 0-.005.006c.002-.004.005-.006.005-.006zM11.354 5a3.174 3.174 0 0 0-.604-.21l-.099.445.055-.013c.286-.072.502-.149.648-.222z" /></svg>
                                        <span class="font-medium text-gray-300">So let`s have a coffee and code?
                                        </span>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div class="w-full px-3 mb-12 lg:w-1/2 order-0 lg:order-1 lg:mb-0">
                            <LottieAnimation lotti={home} />
                            {/* <img class="mx-auto sm:max-w-sm lg:max-w-full" src="https://cdn.devdojo.com/images/november2020/feature-graphic.png" alt="feature image" /> */}
                        </div>
                    </div>
                </div>
            </section>



            <header className='text-2xl font-bold pt-10 pb-5 items-start px-5'>
                <h2 className="heading text-yellow-600">Experience</h2>
            </header>

            <Card />

            <header className='text-2xl font-bold pt-10 pb-5 items-start px-5'>
                <h2 className="heading text-yellow-600">Position of Responsibility</h2>
            </header>

            <Card1 />



            {/* Bubble section */}

            {/* <header className='text-2xl font-bold pt-10 pb-5 items-start px-5 md:pt-2'>
                        <h2 className="heading text-yellow-600">Work Experience</h2>
            </header>
            <section class="text-gray-400 bg-gray-900 body-font">
                <div class="container px-5 py-10 mx-auto flex flex-wrap">
                    {work_info.map((work_info, index) => (
                        <div class="flex relative pt-10 pb-20 sm:items-center md:w-2/3">
                            <div class="h-full w-6 absolute inset-0 flex items-center justify-center">
                                <div class="h-full w-1 bg-gray-600 pointer-events-none"></div>
                            </div>
                            <div class="flex-shrink-0 w-6 h-6 rounded-full mt-10 sm:mt-0 inline-flex items-center justify-center bg-indigo-500 text-white relative z-10 title-font font-medium text-sm">{index + 1}</div>
                            <div class="flex-grow md:pl-8 pl-6 flex sm:items-center items-start flex-col sm:flex-row">
                                <div class="flex-shrink-0 w-24 h-24 bg-gray-100 text-indigo-400 rounded-full inline-flex items-center justify-center">
                                    <img class="image-class" src={work_info.image} alt={work_info.alt} />
                                </div>
                                <div class="flex-grow sm:pl-6 mt-6 sm:mt-0">
                                    <h2 class="font-medium title-font text-white mb-1 text-xl">{work_info.company}</h2>
                                    <div className="header mt-2">
                                        <h4 className="text-gray-400"><div className="role items-start">{work_info.role}</div><div className="years items-end">{work_info.period}</div></h4>
                                    </div>
                                    <p class="leading-relaxed">{work_info.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}






            {/* <div className="App container mx-10 mx-auto max-w-screen-lg container bg-gray-800">



                <div className="work-experience">
                    <header className='text-2xl font-bold pt-10 pb-5 items-start px-5 md:pt-2'>
                        <h2 className="heading">Work Experience</h2>
                    </header>


                    <div className="pt-7 grid lg:grid-cols-2 gap-8">
                        {work_info.map((work_info, index) => (
                            <div className="pb-px cursor-pointer transform duration-500 hover:-translate-y-1">
                                <div className="-mt-16">
                                    <div class="py-5 px-8 bg-gray-900 shadow-lg rounded-lg my-20">
                                        <div class="flex justify-end -mt-16">
                                            <div className="circle-img w-20 h-20 object-cover rounded-full border-1 border-white bg-white">
                                                <img class="image-class" src={work_info.image} alt={work_info.alt} />
                                            </div>
                                        </div>
                                        <div className="-mt-5">
                                            <h2 class="text-regal-blue text-3xl font-semibold">{work_info.company}</h2>
                                            <div className="header mt-2">
                                                <h4 className="text-gray-400"><div className="role items-start">{work_info.role}</div><div className="years items-end">{work_info.period}</div></h4>
                                            </div>
                                            <p class="mt-2 text-gray-300">{work_info.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div> */}


        </div>
    )
}

export default about
